import { render, staticRenderFns } from "./WonderAiReport.vue?vue&type=template&id=e947a48c&scoped=true"
import script from "./WonderAiReport.vue?vue&type=script&lang=js"
export * from "./WonderAiReport.vue?vue&type=script&lang=js"
import style0 from "./WonderAiReport.vue?vue&type=style&index=0&id=e947a48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e947a48c",
  null
  
)

export default component.exports